import { bunja } from 'bunja';
import { atom } from 'jotai';
import { getHook } from 'react-bunja-devtools/hook';

import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

interface Routes {
  brt: { selectedNo?: number };
  dag: { selectedBunjaId?: string };
  flag: {};
  logging: {};
  'build-info': {};
}
const defaultParams: Routes = {
  brt: {},
  dag: {},
  flag: {},
  logging: {},
  'build-info': {},
};
function getDefaultParams<T extends Tab>(tab: T): Route<T> {
  return { tab, params: defaultParams[tab] };
}
// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export function readRouteParams<T extends Tab>(route: Route<any>, tab: T): Routes[T] | undefined {
  if (route.tab !== tab) return;
  return route.params;
}

export type Tab = keyof Routes;
interface Route<T extends Tab> {
  tab: T;
  params: Routes[T];
}

export const devtoolsRouteBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const isBunjaDevtoolsEnabled = Boolean(getHook());

  const lastParamsAtom = atom<Routes>(defaultParams);
  const routeAtom = atom<Route<Tab>>(getDefaultParams(isBunjaDevtoolsEnabled ? 'brt' : 'flag'));

  const currentTabAtom = atom((get) => get(routeAtom).tab);
  function changeTab<T extends Tab>(tab: T, params?: Routes[T]) {
    const oldRoute = store.get(routeAtom);
    const lastParams = store.get(lastParamsAtom);
    const newParams = params ?? lastParams[tab];
    store.set(lastParamsAtom, { ...lastParams, [oldRoute.tab]: oldRoute.params });
    store.set(routeAtom, { tab, params: newParams });
  }

  return {
    isBunjaDevtoolsEnabled,
    routeAtom,
    currentTabAtom,
    changeTab,
  };
});
devtoolsRouteBunja.debugLabel = 'devtoolsRouteBunja';
